import React from "react";
import { AppBar, Toolbar, Box, Typography, Stack, Grid, IconButton } from "@mui/material";

export default function Navbar({open}) {

    const altezza = 40;

    return (
        <AppBar
            position="fixed"
            elevation={0}

            sx={{
                background: "transparent",
                boxShadow: "none",
                zIndex: 100,
                paddingTop: "30px",
                marginX: "10%",
                width: "80%",
            }}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={4}
            >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 4,
                            paddingX: 2,
                            paddingY: 1.5,
                            borderRadius: "50px",
                            background:
                                "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 100%)",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                            width: "fit-content",
                            backdropFilter: "blur(10px)",
                        }}
                    >
                        {/* LOGO */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                transition: "all 0.3s ease",
                                "&:hover": {
                                    fontWeight: 600, // Grassetto all'hover
                                },
                            }}
                        >
                            <img
                                src="/assets/LogoAzzurro.svg" // ⬅️ sostituisci con il tuo percorso
                                alt="Logo Ginnastica Posturale"
                                style={{ height: altezza, cursor: "pointer" }}
                                onClick={() => {
                                    const el = document.getElementById("title");
                                    if (el) {
                                        el.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 4,
                            paddingX: 2,
                            paddingY: 1.5,
                            borderRadius: "50px",
                            background:
                                "linear-gradient(180deg, rgba(255,255,255,0.4) 0%, rgba(255,255,255,0) 100%)",
                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                            backdropFilter: "blur(10px)",
                            height: altezza,
                        }}
                    >
                        <IconButton onClick={() => open()} >
                            <svg width="20" height="20" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="22" height="2.45455" rx="1.22727" fill="#2F4B5B"/>
                                <rect y="7.36363" width="22" height="2.45455" rx="1.22727" fill="#2F4B5B"/>
                                <rect y="15.5455" width="22" height="2.45455" rx="1.22727" fill="#2F4B5B"/>
                            </svg>

                        </IconButton>

                        
                    </Box>
            </Stack>
        </AppBar>
    );
}


